'use client';

import { DatesProvider } from '@mantine/dates';

import 'dayjs/locale/de';

import { FC, PropsWithChildren } from 'react';

const ClientDatesProvider: FC<PropsWithChildren> = ({ children }) => (
  <DatesProvider settings={{ timezone: 'UTC', locale: 'de' }}>{children}</DatesProvider>
);

export { ClientDatesProvider };
